export default __webpack_public_path__ + "1e8202d266986cd665fed78a0efef26f.png";